import { render, staticRenderFns } from "./EntityContactReport.vue?vue&type=template&id=4fa8c8b3&"
import script from "./EntityContactReport.vue?vue&type=script&lang=js&"
export * from "./EntityContactReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports